/**
 * Dashboard Route
 * Versicherten dashboard with appointments and invitations
 */
import { createFileRoute } from "@tanstack/react-router";
import { VersicherteDashboardPage } from "../pages/VersicherteDashboardPage";

export const Route = createFileRoute("/dashboard")({
  component: VersicherteDashboardPage,
});
